// removed by extract-text-webpack-plugin
module.exports = {"take-action-share":"take-action-share___2cSrl center___2iqBf","take-action-label":"take-action-label___2zvxJ","take-action-icons":"take-action-icons___27-sw center___2iqBf","show-results-button":"show-results-button___3g1em"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonStaffTakeActionShare/AmazonStaffTakeActionShare.css
// module id = 876
// module chunks = 0